import { DivFormTitle, DivSubmitButtons, DoneIconStyled, FormStyled } from "../Forms/styles"
import { Typography, IconButton, Dialog } from "@mui/material"
import React, { useEffect, useState } from 'react'
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useDispatch, useSelector } from "react-redux";
import * as actions from '../../../store/actions';
import moment from "moment-timezone";
import { i18n } from "../../../translate/i18n";
import { isEmpty } from "lodash";
import CloseIcon from '@mui/icons-material/Close';
import Autocomplete from '../../../UI/Autocomplete/Autocomplete';
import FormControl from "@mui/material/FormControl";
import Spinner from "../../../components/Spinner/index";
import ConfirmDialog from "../../../UI/Confirm/ConfirmDialog";

export const ModalMassService = (props) => {
    const dispatch = useDispatch();


    const selectedEquipServices = useSelector(state => state.equipmentServices.selectedEquipmentMassServices);
    const loading = useSelector(state => state.equipmentServices.selectedEquipmentMassServicesLoading);

    const [servicesFormatted, setServicesFormatted] = useState([])
    const [selectedService, setSelectedService] = useState([])
    const [selectedServiceData, setSelectedServiceData] = useState({})
    const [indexService, setIndexService] = useState(0)
    const [selectedServiceError, setSelectedServiceError] = useState(false)
    const [isDivergentEquipModels, setIsDivergentEquipModels] = useState(false)
    const [latitude, setLatitude] = useState('');
    const [longitude, setLongitude] = useState('')
    const [startTime, setStartTime] = useState('');

    useEffect(() => {
        if (props.equipments.length > 0 && props.modalMassService) {
          dispatch(actions.fetchSelectedEquipmentMassServices(props.equipments[0].equipmentModel._id))
        }
    }, [props.modalMassService])

    useEffect(() => {
      if (props.equipments.length > 0 && props.modalMassService && !isEmpty(selectedEquipServices)) {
        const isDivergent = props.equipments.length > 0 ? !props.equipments.every(equip => equip.equipmentModel._id.toString() === props.equipments[0].equipmentModel._id.toString()) || !selectedEquipServices.some(service => service.massService) : false;
        setIsDivergentEquipModels(isDivergent)
      }
    }, [props.modalMassService])

    useEffect(() => {
      const dataFromRedux = selectedEquipServices;
      const returnArray = [];
      dataFromRedux.map((dt) =>
        returnArray.push({value: dt._id, label: `${dt.serviceType.name} (${dt.frequency.name})`})
      );
      setServicesFormatted(returnArray);
    }, [selectedEquipServices])

    useEffect(() => {
      const location = window.navigator?.geolocation;
      location.getCurrentPosition((position) => {
        setLatitude(position.coords.latitude.toString())
        setLongitude(position.coords.longitude.toString())
      }, (error) => {
        if (error.message === 'User denied Geolocation') {
          setLatitude('no-authorization')
          setLongitude('no-authorization')
        }
      })
      setStartTime(new Date())
    }, [])

    const handleInputChangeService = (selected) => {
      setIndexService(selectedEquipServices.findIndex(ses => ses._id === selected.value));
      setSelectedServiceError(false);
      setSelectedService(selected);
    };

    const handleInputChangeSelectorServices = (text) => {
      if (text !== '') {
        setServicesFormatted(servicesFormatted.filter(service => service.label.includes(text.toUpperCase())))
      } else {
        setServicesFormatted(selectedEquipServices.map((dt) => ({value: dt._id, label: `${dt.serviceType.name} (${dt.frequency.name})`})))
      }
    }

    //Convert month and day into the correct leter
    const momentShortHand = (name) => {
      switch(name) {
          case 'month':
              return 'M';
          case 'day':
              return 'd';
          default:
              return 'M';
      }
    }

    const getDate = () => selectedEquipServices[indexService].frequency.onDemand ? moment() : moment(selectedServiceData.expiration).subtract(selectedEquipServices[indexService].frequency.amount, momentShortHand(selectedEquipServices[indexService].frequency.type))

    const handleSubmit = () => {
      let hasError = false;

      if (isEmpty(selectedService)) {
        setSelectedServiceError(true);
        hasError = true;
      }

      if (hasError) return;

      const body = {
        date: getDate(),
        equipments: props.equipments.map(equip => ({ _id: equip._id, place: equip.place })),
        equipmentService: selectedService.value,
        comment: `${i18n.t('modalMassService.comment')}`,
        latitude,
        longitude,
        source: 'web',
        serviceTime: {
          start: startTime,
          end: new Date(),
        }
      }

      dispatch(actions.postMassService(body))
      .then(result => {
        if (result !== 'error') {
          props.closeModal()
        }
      })
    }

    const setDeadline = (frequency) => {
      const { type, amount, onDemand } = frequency;
      if (!onDemand) {
        return moment().add(amount, type);
      } else {
        return moment();
      }
    };

    const checkValidDeadline = (frequency, dateSelected) => {
      const { type, amount, onDemand } = frequency;
      if (onDemand) {
        return moment(dateSelected).isBefore(moment().endOf('day'));
      }
      return moment(dateSelected).isBefore(moment().endOf('day').add(amount, type));
    };

    return (!isDivergentEquipModels) ? <Dialog
      maxWidth="xs"
      scroll="body"
      fullWidth
      open={props.modalMassService}
      onClose={() => props.closeModal()}
      PaperProps={{
        style: {
          overflow: 'visible',
        },
      }}
    >
      <FormStyled style={styles.container}>
        {loading && <Spinner overlay />}
        <DivFormTitle  style={styles.opacityContainer}>
          <Typography style={{ paddingBottom: '20px'}} variant="h6">
          {i18n.t('modalMassService.massServiceTipography')}
          </Typography>
        </DivFormTitle>

        <FormControl variant="standard" fullWidth margin="normal" required>
          <Autocomplete
            loading={loading} // sent to isLoading
            label={i18n.t('modalMassService.autocomplete')}
            data={servicesFormatted} // sent to options
            onSelectValue={handleInputChangeService} // sent to onChange
            valueSelected={selectedService} // sent to value
            newSearchText={handleInputChangeSelectorServices}
            name="service"
            hasError={selectedServiceError}
          />
        </FormControl>

        {(!isEmpty(selectedService) && !selectedEquipServices[indexService].frequency.onDemand) &&
          <div>
            <DatePicker
              label={i18n.t('modalMassService.date')}
              margin='normal'
              value={selectedServiceData.expiration && new Date(selectedServiceData.expiration)}
              onChange={(date) => setSelectedServiceData({ expiration: date, isValid: checkValidDeadline(selectedEquipServices[indexService].frequency, date) })}
              format="dd/MM/yyyy"
              maxDate={setDeadline(selectedEquipServices[indexService].frequency)}
              invalidDateMessage={i18n.t('keyboardDatePickerFormEquipServType.invalidDateMessage')}
              maxDateMessage={i18n.t('keyboardDatePickerFormEquipServType.maxDateMessage')}
              style={styles.datepicker}
              slotProps={{ textField: { variant: 'standard', } }}
            />
          </div>}

        <DivSubmitButtons>
          <IconButton onClick={() => props.closeModal()} size="large">
            <CloseIcon fontSize="large" color="error" />
          </IconButton>
          <IconButton onClick={() => handleSubmit()} size="large">
            <DoneIconStyled fontSize="large" />
          </IconButton>
        </DivSubmitButtons>
      </FormStyled>
    </Dialog> : !!props.modalMassService && <ConfirmDialog show={isDivergentEquipModels} proceed={props.closeModal} dismiss={() => props.closeModal()} cancel={props.closeModal} confirmation={`${i18n.t('modalMassService.error')}`} options={{disableBackdrop: false, disableKeyDown: true, title: `${i18n.t('modalMassService.errorTitle')}`, titleColor: 'red'}} />;
}

const styles = {
    opacityContainer: {
      opacity: '1',
      position: 'relative',
    },
    datepicker: {
        width: '100%',
    },
    loadingContainer: {
        position: 'relative',
        height: 70,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
}